export const ABILTYPE = {
  SEX: 2,
  HAIRCOLOR: 3,
  CLASS: 4,
  UNION: 5,
  RANK: 6,
  FAME: 7,
  FACE: 8,
  HAIRSTYLE: 9,
  STR: 10,
  DEX: 11,
  INT: 12,
  CON: 13,
  CHA: 14,
  SEN: 15,
  HP: 16,
  MP: 17,

  ATK: 18,
  DEF: 19,
  HIT: 20,
  RES: 21,
  AVOID: 22,
  SPEED: 23,
  ATK_SPD: 24,
  WEIGHT: 25,
  CRITICAL: 26,
  RECOVER_HP: 27,
  RECOVER_MP: 28,
  SAVE_MP: 29,
  EXP: 30,
  LEVEL: 31,
  BONUSPOINT: 32,
  PK_FLAG: 33,
  TEAM_NO: 34,
  HEAD_SIZE: 35,
  BODY_SIZE: 36,
  SKILLPOINT: 37,
  MAX_HP: 38,
  MAX_MP: 39,
  MONEY: 40,
  CRITICAL_DMG: 41,
  IGNORE_DEF: 42,
  IGNORE_MDEF: 43,
  ENHANCED_DMG: 44,
  ENHANCE_DMG_REDUC: 45,
  MAXHP_PERCENT: 46, // Total HP (%)
  MAXMP_PERCENT: 47, // Total MP (%)
  SKILL_POWER: 48, // Increases Skill attack power
  HEAL_POWER: 49, // Increases Skill heal power
  ATTACK_RANGE: 50, // Increases Ranged Weapon attack range
  SKILL_RANGE: 51, // Increases skill range
  AOE_RADIUS: 52, // Increases AOE skill radius effect
  ALL_STATS: 53, // All Stats
  REFLECT_ATTACK: 54, // Reflect Attack
  MELEE_POWER: 55, // Melee Power

  HP_PERCENT: 56, // Available HP (%)
  MP_PERCENT: 57, // Available MP (%)

  PSV_BUYING: 59,
  PSV_SELLING: 60,

  SUMMON_MOB_CNT: 62,

  BUFF_ENHANCE: 64,
  SHIELD_MDEF: 65,
  SHIELD_BLOCK_RATE: 66,
  SHIELD_DEF: 67,

  R_WEAPON_TYPE: 68, // Right/Main Weapon Type
  L_WEAPON_TYPE: 69, // Left/Off-Hand Weapon Type

  CRAFT_TALENT: 70,
  RACE: 71,
  DROP_RATE: 72,
  FAME_G: 73,
  FAME_B: 74,
  CURRENT_PLANET: 75,
  STAMINA: 76,
  FUEL: 77,
  IMMUNITY: 78,
  DROP_COUNT_RATE: 79,

  CURRENCY_BEGIN: 81,
  CURRENCY_END: 90,

  CURRENCY_HONOR: 81,
  CURRENCY_VALOR: 82,
  CURRENCY3: 83,
  CURRENCY4: 84,
  CURRENCY_PREMIUM_POINTS: 85, // Premium Points
  CURRENCY_GAMEARENA_ENERGY: 86, // Game Arena Energy
  CURRENCY7: 87,
  CURRENCY8: 88,
  CURRENCY9: 89,
  CURRENCY10: 90,

  GUILD_NO: 91,
  GUILD_SCORE: 92,
  GUILD_POS: 93,
  MAINTAIN_ABILITY: 94,
  BANK_FREE: 94,
  BANK_ADDON: 95,
  STORE_SKIN: 96,
  PHP: 97,
  MAX_PHP: 98,
  GAMEARENA_TEAM_SIZE: 99, // Game Arena Team Size

  PSV_EXPERIENCE_ITEM: 133,
  PSV_DROP_QUANTITY: 134,
  PSV_DROP_QUALITY: 135,
  PSV_DROP_LOWLEVEL: 136,
  PSV_NO_DEATH_PENALTY: 137,
  PSV_NO_EXP_GAIN: 138,
  BANK_ADDON2: 139,
  BANK_ADDON3: 140,
  BANK_ADDON4: 141,
  QUESTEMOTICON: 142,
  ADJUST_RECEIVE_HP_ALL: 143, // Adjust Incoming HP From All Sources (%)
  ADJUST_RECEIVE_MP_ALL: 144, // Adjust Incoming MP From All Sources (%)
  ADJUST_RECEIVE_HP_SKILL: 145, // Adjust Incoming HP From Skill Sources (%)
  ADJUST_RECEIVE_MP_SKILL: 146, // Adjust Incoming MP From Skill Sources (%)
  ADJUST_RECEIVE_HP_CONSUME: 147, // Adjust Incoming HP From Consumable Item Sources (%)
  ADJUST_RECEIVE_MP_CONSUME: 148, // Adjust Incoming MP From Consumable Item Sources (%)
  REDUCE_STATUS_EFFECT_ALL: 149, // Reduce Success Rate Of Being Hit By All Harmful Status Effects (%)
  REDUCE_STATUS_EFFECT_STUN: 150, // Reduce Success Rate Of Being Hit By Stun (%)
  REDUCE_STATUS_EFFECT_MUTE: 151, // Reduce Success Rate Of Being Hit By Mute (%)
  REDUCE_STATUS_EFFECT_SLEEP: 152, // Reduce Success Rate Of Being Hit By Sleep (%)
  DROP_MONEY_QTY: 153, // Increase Minimum & Maximum Quantity of Zulie Drops (%)
  DROP_ITEM_QTY_MIN: 154, // Increase Minimum Quantity of Stackable Item Drops
  DROP_ITEM_QTY_MAX: 155, // Increase Maximum Quantity of Stackable Item Drops
  BASE_ATTRIBUTE: 156, // Global Attribute From Equipment / Passive Skill
  ATK_ATTRIBUTE: 157, // Offensive Attribute From Equipment / Passive Skill
  DEF_ATTRIBUTE: 158, // Defensive Attribute From Equipment / Passive Skill

  DROP_CATEGORY_RATE_BEGIN: 160,
  DROP_CATEGORY_RATE_END: 165,

  DROP_CATEGORY_RATE_COMMON: 160,
  DROP_CATEGORY_RATE_UNCOMMON: 161,
  DROP_CATEGORY_RATE_RARE: 162,
  DROP_CATEGORY_RATE_VERYRARE: 163,
  DROP_CATEGORY_RATE_EPIC: 164,
  DROP_CATEGORY_RATE_LEGENDARY: 165,

  HOBBY_EXP: 166,
  HOBBY_LEVEL: 167,
  HOBBY_POINT: 168,

  // TODO: Maybe move MAX?
  MAX: 169,

  // Unofficial Values
  BIRTH: 1000
};
